import { forwardRef, memo } from "react";

export const ComputingIcon = memo(
  forwardRef(function ComputingIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M11.9629 8.83789C13.1745 8.83789 14.1602 7.8522 14.1602 6.64062C14.0395 3.72563 9.88589 3.72651 9.76562 6.64062C9.76562 7.8522 10.7513 8.83789 11.9629 8.83789ZM11.9629 5.9082C12.3667 5.9082 12.6953 6.23677 12.6953 6.64062C12.6551 7.6123 11.2706 7.61201 11.2305 6.64062C11.2305 6.23677 11.559 5.9082 11.9629 5.9082Z"
          fill={color}
        />
        <path
          d="M23.9258 20.5566V4.15039H18.1931L16.687 1.54165L14.7966 2.30903C14.6356 2.20356 14.4689 2.10718 14.2973 2.02036L14.0167 0H9.90918L9.62856 2.02036C9.45688 2.10718 9.29019 2.20356 9.1292 2.30903L7.23887 1.54165L5.73272 4.15039H0V20.5566H8.81348V23.5352H7.34863V25H16.5771V23.5352H15.1123V20.5566H23.9258ZM8.28804 7.1582C8.21143 6.68389 8.27187 6.17632 8.34644 5.70405L7.09141 4.72681L7.86968 3.37876L9.34453 3.97744C9.71577 3.67593 10.1242 3.36929 10.5731 3.19888L10.9658 3.04009L11.1846 1.46489H12.7412L12.9599 3.04009L13.3526 3.19888C13.8005 3.36865 14.2109 3.67666 14.5812 3.97744L16.0561 3.37876L16.8343 4.72681L15.5793 5.70405C15.6186 5.98994 15.6792 6.35532 15.6737 6.64067C15.6793 6.92495 15.6185 7.29287 15.5793 7.57729L16.8343 8.55454L16.0561 9.90259L14.5812 9.30391C14.21 9.60542 13.8015 9.91206 13.3526 10.0825L12.9599 10.2413L12.7412 11.8165H11.1846L10.9658 10.2413L10.5731 10.0825C10.1252 9.91269 9.7148 9.60469 9.34453 9.30391L7.86968 9.90259L7.09141 8.55454L8.34644 7.57729L8.28804 7.1582ZM5.84814 5.61523L6.79517 6.35269C6.78442 6.54526 6.78442 6.73603 6.79517 6.92861L5.18506 8.18237L7.23882 11.7396L9.12915 10.9723C9.29014 11.0777 9.45684 11.1741 9.62852 11.2609L9.90913 13.2812H14.0166L14.2972 11.2609C14.4689 11.1741 14.6356 11.0777 14.7966 10.9722L16.6869 11.7396L18.7407 8.18232L17.1306 6.92856C17.1413 6.73599 17.1413 6.54522 17.1306 6.35264L18.0776 5.61523H22.4609V16.1621H1.46484V5.61523H5.84814ZM1.46484 17.627H22.4609V19.0918H1.46484V17.627ZM13.6475 23.5352H10.2783V20.5566H13.6475V23.5352Z"
          fill={color}
        />
      </svg>
    );
  }),
);

ComputingIcon.displayName = "ComputingIcon";